module.exports = __webpack_public_path__ + "img/gry_bg.0ac411f9.jpg";